import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import { queryClient } from './api/reactQueryInstance';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SideBarProvider } from './context/sidebar.context';
import { GlobalStatesProvider } from './context/globalStates.context';
import { FormProvider } from './context/form.context';
import MainRouter from './routes';
import { Provider } from 'react-redux';

import { store } from "./redux/store";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <GlobalStatesProvider>
          <FormProvider>
            <SideBarProvider>
              <RouterProvider router={MainRouter} />
            </SideBarProvider>
          </FormProvider>
        </GlobalStatesProvider>
      </Provider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </React.StrictMode>
);
